import { WarningIcon } from "@phosphor-icons/react/dist/csr/Warning";
import { cn } from "@volca/ui/lib/utils";
import { AttentionCount } from "./attention-count";
import type { SidebarSection } from "./nav-items";

// The trailing warning and count on a nav row, shared by the desktop column
// and the phone drawer.
export const SectionStatus = ({ section }: { section: SidebarSection }) => (
  <>
    {section.warning && (
      <WarningIcon
        weight="fill"
        role="img"
        aria-label={section.warning}
        className={cn("size-4 shrink-0 text-warning", {
          "ml-auto": !section.count,
        })}
      />
    )}
    {section.count ? (
      <AttentionCount
        count={section.count}
        isPartial={section.countIsPartial}
        label={
          section.countLabel ??
          (section.count === 1 && !section.countIsPartial ? "item" : "items")
        }
        className="ml-auto"
      />
    ) : null}
  </>
);
